
export const words: { [key: string]: { [key: string]: string; }} = {

    //defaultSignin:     { heb: 'כניסה דרך ההזדהות האחידה', arab: 'כניסה דרך ההזדהות האחידה' },
    //credentialsSignin: { heb: 'כניסה עם שם משתמש וסיסמה', arab: 'الدخول من خلال اسم المستخدم والرقم السري' },
    //userName:          { heb: 'שם משתמש',                 arab: 'الاسم' },
    //password:          { heb: 'סיסמה',                    arab: 'סיסמה' },
    //resetPassword:     { heb: 'לאיפוס סיסמה',             arab: 'לאיפוס סיסמה' },
    about:             { heb: 'מה באתר',                  arab: 'ماذا يوجد في الموقع' },
    pisa_questions:    { heb: 'שאלות ברוח פיזה',          arab: 'تَمارِين بيزا PISA ' },
    classes:           { heb: 'פרקי רענון',               arab: 'فصول تحديثية' },
    enterTeacherCode:  { heb: 'הזן קוד מורה',             arab: 'ادخل رمز المعلم' },
    changeTeacherCode: { heb: 'שנה קוד מורה',             arab: 'تغير رمز المعلم' },
    teacherCode:       { heb: 'קוד מורה',                 arab: 'رمز المعلم' },
    myTeacherCode:     { heb: 'קוד המורה שלך הוא',        arab: 'رمز معلمك الخاص هو' },
    ok:                { heb: 'אישור',                    arab: 'موافق' },
    emptyCode:         { heb: 'חובה להזין קוד',           arab: 'ملزم  بادخال الرمز' },
    studentResults:    { heb: 'ציוני תלמידים',            arab: 'علامات الطلاب' },
    submissionNum:     { heb: 'מספר המגישים',             arab: 'عدد المرسلين' },
    showStudentInfo:   { heb: 'הצגת נתוני תלמידים',       arab: 'عرض نتائج الطلاب' },
    signOut:           { heb: 'התנתק',                    arab: 'تسجيل الخروج' },
    inputIsNaN:        { heb: `חובה להזין ספרות בלבד`,    arab: `ملزم  بكتابة ارقام لوحدها` },
    loading:           { heb: `אנא המתן`,                 arab: `انتظار` },
    signIn:            { heb: `לחץ להתחברות`,             arab: `اضغط للاتصال` },
    showTopics:        { heb: `הצגת נושאים`,              arab: `הצגת נושאים` },
}






/*

G_heb_to_ar_add["שם"]="الاسم"
G_heb_to_ar_add["מייל"]="الْبَرِيد الإلِكْتُرُونِيّ "
G_heb_to_ar_add["שם המורה"]="إسْم الْمُعَلِّم "
G_heb_to_ar_add["בית ספר"]="المدرسة"
G_heb_to_ar_add["בואו נתחיל"]="هيا نبدأ"
G_heb_to_ar_add["התנתק"]="تَسْجِيل الْخُرُوج "
G_heb_to_ar_add["מבואות"]="مُقَدِّمَات "

G_heb_to_ar_add["התנתק"]="تَسْجِيل الْخُرُوج ";
G_heb_to_ar_add["שאלות ברוח פיזה"]="تَمارِين بيزا PISA ";
G_heb_to_ar_add["מה באתר"]="ماذا يوجد في الموقع";
G_heb_to_ar_add['תרגילי פיז"ה']="تَمارِين بيزا PISA "
G_heb_to_ar_add['ערבית']="عربي "
G_heb_to_ar_add["פרקי רענון"]="فصول تحديثية"

*/